import Vue from 'vue'
import App from './App'
import store from "./store"
import request from './request/request'
import Cookies from 'js-cookie'
import PubSub from 'pubsub-js'
import 'lib-flexible'

// import VideoPlayer from 'vue-video-player'
// import 'vue-video-player/src/custom-theme.css'
// //播放rtmp视频
// import 'videojs-flash'
// //引入 hls,视频直播(m3u8)必须引入的
// import 'videojs-contrib-hls'
// import 'video.js/dist/video-js.css'
// Vue.use(VideoPlayer)


// 时间格式化插件cnpmmoment.locale('zh-cn')
import moment from 'moment'
moment.locale('zh-cn')
Vue.prototype.$moment = moment;

// 组件 公共方法
import GlobalFun from '@/global/global-function'
Vue.prototype.$GlobalFun = GlobalFun;

import ElementUI from 'element-ui'
// 引入组件库的css样式
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import JsonViewer from 'vue-json-viewer'
Vue.use(JsonViewer)

import elTableInfiniteScroll from 'el-table-infinite-scroll'
Vue.use(elTableInfiniteScroll)

// 复制到剪切板
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

// 右键菜单
import Contextmenu from "vue-contextmenujs";
Vue.use(Contextmenu);

/** 大数据表格UI */
import 'umy-ui/lib/theme-chalk/index.css';// 引入样式
import UmyUi from 'umy-ui'
Vue.use(UmyUi);

// 引入iconfont图标库
import '@/assets/el-iconfont/iconfont.css'

// 引入全局的css样式控制文件 公共样式
import '@/static_dazzle/css/global.scss'
// 引入全局的css样式控制文件 树形结构
import '@/static_dazzle/css/common/tree-table-view.scss'
// 引入全局的css样式控制文件 地图定位组件
import '@/static_dazzle/css/common/position-map-view.scss'
// 引入全局的css样式控制文件 dialog message
import '@/static_dazzle/css/common/dialog-message-view.scss'
// 引入全局的css样式控制文件 组织结构（表单）
import '@/static_dazzle/css/common/form-model-view.scss'
// 引入全局的scss样式控制文件 自定义按钮（-表单-）
import '@/static_dazzle/css/custom-buttons.scss'
// 引入全局的scss样式控制文件 AMap相关样式
import '@/static_dazzle/css/amap/amap.scss'

// 引入全局的css样式控制文件 公共样式 左右结构
import '@/static_dazzle/css/global-LR.scss'

// 引入自定义指令
import '@/components/utils/directives.js';

// 消息 弹窗
import { Notification, MessageBox, Message } from 'element-ui'
// 公共 校验
import {checkEmpty, checkLoginDevice} from '@/global/global-valid'
// HanshMap
import {HashMap} from '@/static_dazzle/plugins/tools/hashmap'
// 引入基本模板
import * as echarts from 'echarts';
require('echarts/theme/macarons');

// SubFn
import {SubFn} from '@/global/global-sub-function'

// Secret 加密
import Secret from '@/secret'

import Router from 'vue-router'
import router from './router/index'

// 全局方法挂载
Vue.prototype.$cookies = Cookies// Cookies
Vue.prototype.$request = request// request
Vue.prototype.$checkEmpty = checkEmpty// checkEmpty
Vue.prototype.$checkLoginDevice = checkLoginDevice// checkLoginDevice
Vue.prototype.$pubsub = PubSub// PubSub
Vue.prototype.HashMap = HashMap// HashMap
Vue.prototype.$bus = new Vue();// bus
Vue.prototype.$echarts = echarts// echarts
Vue.prototype.$secret = Secret;// Secret 加密

Vue.prototype.$SubFn = new SubFn();// SubFn

Vue.config.productionTip = false

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

/*
    路由验证：要在加载vue之前
    to即将进入的目标路由对象，
    from当前导航正要离开的路由，
    next : 下一步执行的函数钩子
 */
router.beforeEach((to, from, next) => {
    // console.log(from, to)
    let allowItems = ['/automap', '/outdoorMonitor'];
    let testFlag = (allowItems.indexOf(to.path) > -1 || to.path.indexOf('manager') > -1);
    // 判断是否进入登录路由
    if(to.path === '/' || to.path === '/login' || testFlag) {
        /* 进入登录 */
        next();
    } else {
        /* 进入系统 */
        let token = store.state.token;
        if(to.meta.requireAuth && (!token || token == '')) {
            //需要权限才能访问
            Message('登录已失效，请重新登录！');
            next({path:'/'})
        }else{
            if(from.path === '/' || from.path === '/login'){
                // 获取路由
                let userRouter = store.state.userRouter;
                if(!userRouter || userRouter == '' || JSON.parse(store.state.userRouter).length == 0){
                    Message('访问权限已失效，自动退出登录！');
                    next({path:'/'})
                } else{
                    if(checkUserRouter(to.path)) {
                        next();
                    } else {
                        next({path: JSON.parse(store.state.userRouter)[0]})
                    }
                }
            }else {
                if(checkUserRouter(to.path)){
                    next();
                }else{
                    next({path:'/'})
                }
            }
        }
    }
})

/**
 * 检查
 * @param path
 * @param requireAuth
 * @returns {boolean}
 */
function checkUserRouter(path){
    let checkPassed = false;
    if(store.state.userRouter == ''){
        return checkPassed;
    }
    let userRouter = JSON.parse(store.state.userRouter);
    try{
        userRouter.forEach((row, index) => {
            if(row == path){
                checkPassed = true;
                throw new Error("EndIterative");
            }
        });
    } catch (e) {
        if (e.message != 'EndIterative') throw e;
    }
    return checkPassed;
}

/**
 * 组件
 */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js